/* Next10 — topo da PDP: selo na galeria, modal de formas de
   pagamento e cálculo de frete.

   O card de compra (.n10-buy-card / .n10-buy-row) é montado no Liquid,
   em product-variant-picker.liquid + buy-buttons.liquid — aqui nada é
   reordenado, para não interferir na troca de variante do tema. */
(function () {
  'use strict';

  /* ---------- selo: único e dentro da galeria ---------- */
  function moverBadges(root) {
    /* Alvo: o <media-gallery> (a foto), nao o wrapper da coluna. O wrapper
       engloba tambem os icones e as 2 fotos lifestyle, entao o selo ficava
       ancorado no topo da coluna inteira e saia da tela no scroll. */
    var media = root.querySelector('.product__media-wrapper media-gallery')
      || root.querySelector('.product__media-wrapper');
    if (!media) return;
    var todos = Array.prototype.slice.call(root.querySelectorAll('[data-n10-badges]'));
    if (!todos.length) return;
    var atual = todos[todos.length - 1];
    todos.forEach(function (b) { if (b !== atual) b.remove(); });
    if (atual.parentNode !== media) media.insertBefore(atual, media.firstChild);
  }

  /* ---------- modal ----------
     Precisa viver no <body>: ancestrais com transform (animações do tema)
     quebram o position: fixed. */
  function initModal(root) {
    root.querySelectorAll('.n10-modal').forEach(function (modal) {
      var antigo = document.getElementById(modal.id);
      if (antigo && antigo !== modal && antigo.parentNode === document.body) antigo.remove();
      if (modal.parentNode !== document.body) document.body.appendChild(modal);
      if (modal.dataset.n10Ready) return;
      modal.dataset.n10Ready = '1';
      modal.addEventListener('click', function (e) {
        if (e.target === modal || (e.target.closest && e.target.closest('[data-n10-close]'))) modal.hidden = true;
      });
    });

    root.querySelectorAll('[data-n10-open]').forEach(function (btn) {
      if (btn.dataset.n10Ready) return;
      btn.dataset.n10Ready = '1';
      btn.addEventListener('click', function () {
        var el = document.getElementById(btn.getAttribute('data-n10-open'));
        if (el) el.hidden = false;
      });
    });
  }

  /* ---------- frete ---------- */
  function dinheiro(centavos) {
    return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function initFrete(root) {
    root.querySelectorAll('[data-n10-frete]').forEach(function (box) {
      if (box.dataset.n10Ready) return;
      box.dataset.n10Ready = '1';

      var input = box.querySelector('[data-n10-cep]');
      var btn = box.querySelector('[data-n10-cep-ok]');
      var out = box.querySelector('[data-n10-frete-resultado]');
      if (!input || !btn || !out) return;

      input.addEventListener('input', function () {
        var v = input.value.replace(/\D/g, '').slice(0, 8);
        input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
      });

      function calcular() {
        var cep = input.value.replace(/\D/g, '');
        if (cep.length !== 8) {
          out.innerHTML = '<p>Digite um CEP válido com 8 dígitos.</p>';
          return;
        }
        out.innerHTML = '<p>Calculando…</p>';

        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!cart.item_count) {
              out.innerHTML = '<p>Adicione o produto ao carrinho para calcular o frete para ' +
                input.value + '.</p>';
              return null;
            }
            var url = '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + encodeURIComponent(cep) +
              '&shipping_address%5Bcountry%5D=Brazil';
            return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (data) {
            if (!data) return;
            var taxas = data.shipping_rates || [];
            if (!taxas.length) {
              out.innerHTML = '<p>Não encontramos opções de entrega para este CEP.</p>';
              return;
            }
            var html = '<ul>';
            taxas.forEach(function (t) {
              var preco = Math.round(parseFloat(t.price) * 100);
              html += '<li><span>' + t.name + '</span><span>' +
                (preco === 0 ? 'Grátis' : dinheiro(preco)) + '</span></li>';
            });
            out.innerHTML = html + '</ul>';
          })
          .catch(function () {
            out.innerHTML = '<p>Não foi possível calcular o frete agora. Tente novamente.</p>';
          });
      }

      btn.addEventListener('click', calcular);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); calcular(); }
      });
    });
  }

  function init() {
    if (!document.querySelector('product-info')) return;
    moverBadges(document);
    initModal(document);
    initFrete(document);
  }

  var pendente = null;
  function agendar() {
    if (pendente) return;
    pendente = setTimeout(function () { pendente = null; init(); }, 150);
  }

  function observar() {
    document.querySelectorAll('product-info').forEach(function (el) {
      if (el.dataset.n10Obs) return;
      el.dataset.n10Obs = '1';
      new MutationObserver(agendar).observe(el, { childList: true, subtree: true });
    });
  }

  function start() { init(); observar(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.n10-modal:not([hidden])').forEach(function (m) { m.hidden = true; });
  });
})();
